import React from 'react';
import { useLocation } from 'react-router-dom';
import { findNav } from 'layouts/nav-config';
import { useIsEmbedded } from 'components/tabbed-page/embedded';
import styles from './style.module.scss';

interface Props {
  title: string;
  style?: any;
  /** Mặc định lấy mô tả của trang trong layouts/nav-config.tsx. Truyền `false` để ẩn. */
  description?: React.ReactNode | false;
  /** Nút hành động chính của trang (Tạo mới, Xuất Excel...), nằm bên phải tiêu đề. */
  extra?: React.ReactNode;
}

/**
 * Đầu trang dùng chung: tiêu đề + một câu "trang này để làm gì" + nút hành động.
 *
 * Tiêu đề lấy theo TÊN MENU trong layouts/nav-config.tsx để menu, breadcrumb và
 * đầu trang luôn gọi cùng một tên (trước đây trang Quốc gia ghi "Quản lí tin tức",
 * trang Tăng ca ghi "Danh sách overtime"...). `title` chỉ dùng khi trang không có
 * trong menu. Các trang cũ chỉ truyền `title` vẫn chạy như trước.
 */
const PageTitle = ({ title, style, description, extra }: Props) => {
  const location = useLocation();
  const embedded = useIsEmbedded();
  const match = findNav(location.pathname);
  // Nằm trong một tab của TabbedPage: trang cha đã có tiêu đề, chỉ giữ nút hành động.
  if (embedded) {
    return extra ? <div className={styles.embeddedExtra}>{extra}</div> : null;
  }
  const heading = match?.item.key ? match.item.label : title;
  const text = description === false ? undefined : description ?? match?.item.description;

  return (
    <div className={styles.pageHeader} style={style}>
      <div className={styles.titleBlock}>
        <h1 className={styles.pageTitle}>{heading}</h1>
        {text && <p className={styles.description}>{text}</p>}
      </div>
      {extra && <div className={styles.extra}>{extra}</div>}
    </div>
  );
};

export default PageTitle;
